/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2024 ICEMEDX, Inc.
***********************************************/
import { claim } from "./claim";

export class claimindex extends claim {
  claim_bucket_key: string = "";
  date_required: any = NaN;
  end_date_required: any = NaN;

  constructor() {
    super();
  }

  gettablename(): string {
    return "CLAIM_INDEX";
  }
}
